import styles from './ServiceBtn.module.css';
import { Link } from 'react-router-dom';

export const ServiceBtn = ({ img, title, underTitle, description, url, state, imgStyle, style }) => {
	return (
		<Link className={styles.link} to={url} state={state}>
			<div style={style} className={styles.main}>
					<div className={styles.left_block}>
						<div className={styles.titleBlock}>
							<img src={img} alt="serviceImg" width={25} height={25} style={imgStyle} />
							<p className={styles.title}>{title}</p>
						</div>
							<p className={styles.underTitle}>{underTitle}</p>
							<p className={styles.description}>{description}</p>
					</div>
			</div>
		</Link>
	);
};
